var React = require('react');

function Reset (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.65 4.35A8 8 0 1 0 17.4 13h-2.22a6 6 0 1 1-1-7.22L11 9h7V2z"}));
}

Reset.defaultProps = {"width":"24","height":"24","viewBox":"0 0 18 24","fill":"none","stroke":"currentColor"};

module.exports = Reset;

Reset.default = Reset;
